<template>
  <div class="d-flex align-items-center">
    <div class="d-flex" role="toolbar" aria-label="Note editor button toolbar">
      <div
        class="btn-group"
        :class="{'ml-2': index > 0 && buttons.length > 0}"
        role="group"
        :aria-label="group"
        v-for="(buttons, group, index) in buttonGroups"
        :key="group"
      >
        <span
          class="btn btn-light btn-toolbar btn-sm"
          @click="button.action"
          v-for="button in buttons"
          :key="button.key"
          :class="{'active': activeMode === button.mode}"
        >
          <i class="fas fa-fw mx-1 button-icon" :class="`fa-${button.icon}`"></i>
        </span>
      </div>
    </div>
    <Modal v-if="showDeleteModal" :show-header="false" :show-footer="true" @close="showDeleteModal=false">
      <template v-slot:body>
        <div class="py-2">Are you sure you want to delete this note?</div>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" @click="deleteNote">Delete note</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="showDeleteModal=false">Close</button>
      </template>
    </Modal>

    <Modal v-if="showSetRootModal" :show-header="false" :show-footer="true" @close="showSetRootModal=false">
      <template v-slot:body>
        <div class="py-2">Are you sure you want to set this note as root?</div>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" @click="setRootNote">Set current note as root</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="showSetRootModal=false">Close</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  props: ['activeMode', 'noteCanBeDeleted', 'noteIsRoot'],
  data() {
    return {
      // modes: {
      //   'rich': {
      //     icon: 'pen'
      //   },
      //   'md': {
      //     icon: 'code'
      //   }
      // },
      buttons: [
        {
          icon: 'pen',
          group: 'modes',
          mode: 'rich',
          action: () => this.$emit('set-mode', 'rich')
        }, {
          icon: 'code',
          group: 'modes',
          mode: 'md',
          action: () => this.$emit('set-mode', 'md')
        },
        {
          icon: 'trash',
          group: 'actions',
          action: () => {
            this.showDeleteModal = true
          },
          show: () => this.noteCanBeDeleted
        }, {
          icon: 'sitemap',
          group: 'actions',
          action: () => {
            this.showSetRootModal = true
          },
          show: () => !this.noteIsRoot
        }
      ],
      showDeleteModal: false,
      showSetRootModal: false
    }
  },
  computed: {
    visibleButtons() {
      return this.buttons.filter(button => {
        return button.show ? button.show() : true
      })
    },
    buttonGroups() {
      // return this.buttons.map(b => b.group).filter((b, index, self) => self.indexOf(b) === index)
      return this.visibleButtons.reduce((groups, button) => {
        groups[button.group] = [...(groups[button.group] || []), button]
        return groups
      }, {})
    }
  },
  methods: {
    deleteNote() {
      this.$emit('delete')
      this.showDeleteModal = false
    },
    setRootNote() {
      this.$emit('set-root')
      this.showSetRootModal = false
    }
  },
  watch: {
    $route() {
      this.showSetRootModal = false
      this.showDeleteModal = false
    }
  }
}
</script>

<style scoped lang="scss">
$button-color: $gray-600;
.btn-toolbar {
  border-color: $app-border-color !important;
  color: $button-color;
  padding: $spacer * 0.5;
  cursor: pointer;
}
.btn-toolbar.active {
  color: $white !important;
  background-color: $primary !important;
  border-color: $primary !important;
}
.btn-toolbar:not(.active):hover {
  background-color: $gray-300 !important;
}
.dropdown-item {
  cursor: pointer;
}
.button-icon {
  font-size: 0.7rem;
}
</style>
